export function fwcColor(token) {
  return token;
}
export function fwcBorderRadius(token) {
  return token;
}
export function fwcBorderWidth(token) {
  return token;
}
export function fwcFontSize(token) {
  return token;
}
export function fwcFontWeight(token) {
  return token;
}